<div class="sidenav-container" [class.sidenav-is-mobile]="sidenav.mode === 'over'">
  @if (toolbar()) {
  <mat-toolbar class="sidenav-toolbar">
    <!-- BOTON MENU -->
    <div class="sidenav-toolbar__start">
      @if (showMenuButton()) {
      <button mat-icon-button (click)="sidenav.toggle()" class="sidenav-toolbar__menu-btn" aria-label="Botón sidenav">
        <mat-icon class="sidenav-toolbar__icon">
          {{ sidenav.opened ? 'close' : 'menu' }}
        </mat-icon>
      </button>
      }
      <div class="sidenav-toolbar__brand" [appOpenInNewTab]="'/mantenimiento'">
        <span class="sidenav-toolbar__brand-condor">CONDOR</span>
        <span class="sidenav-toolbar__brand-module">mantenimiento</span>
      </div>
    </div>
    <!-- DESPLEGABLE USUARIO -->
    <div class="sidenav-toolbar__end">
      <ng-container *transloco="let translate; read: 'sidenav-profile'">
        <div class="sidenav-toolbar__user-info">
          <div class="sidenav-toolbar__user-details">
            <span class="sidenav-toolbar__user-name">{{ entorno() }} / {{ dusuario() }}</span>
            <span class="sidenav-toolbar__user-role">{{ descnivelportal() }}</span>
          </div>
          <button mat-icon-button [matMenuTriggerFor]="matMenu" aria-label="Abrir menú de opciones"
            class="sidenav-toolbar__dropdown-btn">
            <mat-icon class="sidenav-toolbar__icon">arrow_drop_down</mat-icon>
          </button>
        </div>
        <mat-menu #matMenu="matMenu" xPosition="before">
          <button mat-menu-item [routerLink]="['/mantenimiento']">
            <mat-icon>build</mat-icon>
            <span>{{ 'routing.MANT' | transloco }}</span>
          </button>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>{{ translate("logout") }}</span>
          </button>
        </mat-menu>
      </ng-container>
    </div>
  </mat-toolbar>
  }
  <mat-sidenav-container class="sidenav-body">
    <mat-sidenav #sidenav mode="side" class="mat-elevation-z2">
      <mat-nav-list>
        <tree-menu [dataMenuTree]="routesTreeData()"></tree-menu>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <ng-content></ng-content>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>